import { useEffect, useState } from 'react'
import { ApplicationQuestionnaire, company, customerData } from '../../utilities/CustomerData'
import { AdvancePaymentQuestionnaire } from './RefundCalculatedSteps/AdvancePaymentQuestionnaire'
import { AdvancePaymentESign } from './RefundCalculatedSteps/AdvancePaymentESign'
import { apiURL } from '../../utilities/URLs'
import { AdvancePaymentESignAgreement } from './RefundCalculatedSteps/AdvancePaymentESignAgreement'
import { ESignResign } from './ESignResign'

export function Resign() {
  const [step, setStep] = useState(0)
  const [application, setApplication] = useState(customerData.customerAdvanceFunding)
  const [applicationQuestionnaire, setApplicationQuestionnaire] = useState(new ApplicationQuestionnaire())

  /**
   * @param {ApplicationQuestionnaire} applicationQuestionnaire 
   */
  const handleCompleteQuestionnaire = (applicationQuestionnaire) => {
    setApplicationQuestionnaire(applicationQuestionnaire)
    setStep(step+1)
  }

  useEffect(() => {
    if(applicationQuestionnaire.businessName)
      setStep(step + 1)
  }, [applicationQuestionnaire])

  useEffect(() => {
    document.title = `${company.companyName} | E-Sign`
  }, [])

  return (
    <div className='w-screen flex flex-col items-center mt-4 font-robo'>
      {step === 0 ? (
        <AdvancePaymentESignAgreement
          step={step}
          setStep={setStep}
        />
      ) : step === 1 ? (
        <AdvancePaymentQuestionnaire
          handleCompleteQuestionnaire={handleCompleteQuestionnaire}
        />
      ) : (
        <ESignResign
          applicationQuestionnaire={applicationQuestionnaire}
        />
      )}
    </div>
  )
}